import Icon from "@react-native-vector-icons/material-design-icons/static";
/* -----------------UI--------------- */
import { Button, Dialog } from "react-native-paper";
/* -----------------Child components--------------- */

import { isWeb } from "@memorang/helpers/platform";
import CardContent from "@memorang/ui/components/Cards/StudySessionPerformanceCard/CardContent";
import type { Section } from "@memorang/ui/components/Cards/StudySessionPerformanceCard/types";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import { useEffect } from "react";

/* -----------------Props--------------- */

export type CheckboxType =
	| "correct"
	| "incorrect"
	| "skipped"
	| "almostcorrect"
	| "marked";
export type CheckboxStateMap = Record<CheckboxType, boolean>;

type Props = {
	open: boolean;
	handleReview: (checkboxStateMap: CheckboxStateMap) => void;
	numIncorrect?: number;
	handleClose: () => void;
	loading?: boolean;
	sections: Section[];
	handleChangeCheckboxStateMap: (key: keyof CheckboxStateMap) => void;
	handleUpdateIncorrectCheckboxStateMap: () => void;
	checkboxStateMap: CheckboxStateMap;
};

/* -----------------Component--------------- */
const ReviewAnswersDialog = (props: Props) => {
	const {
		handleReview,
		open,
		handleClose,
		loading,
		sections,
		checkboxStateMap,
		handleChangeCheckboxStateMap,
		handleUpdateIncorrectCheckboxStateMap,
		numIncorrect,
	} = props;

	useEffect(() => {
		if (numIncorrect) {
			handleUpdateIncorrectCheckboxStateMap();
		}
	}, [handleUpdateIncorrectCheckboxStateMap, numIncorrect]);

	const Header = () => {
		return (
			<>
				<Dialog.Icon
					icon={(props) => (
						<Icon
							{...props}
							name="order-bool-descending-variant"
							size={24}
							accessibilityLabel="Review answers"
						/>
					)}
				/>
				<Dialog.Title
					style={{
						textAlign: "center",
					}}
				>
					Review answers
				</Dialog.Title>
			</>
		);
	};

	const areAllKeysUnchecked = Object.keys(checkboxStateMap).every(
		(key) => !checkboxStateMap[key as "correct" | "incorrect" | "skipped"],
	);

	const Actions = () => {
		return (
			<Dialog.Actions
				style={{
					paddingRight: 16,
				}}
			>
				<Button
					disabled={loading || areAllKeysUnchecked}
					loading={loading}
					onPress={() => {
						handleReview(checkboxStateMap);
					}}
				>
					Review selected
				</Button>
			</Dialog.Actions>
		);
	};

	return (
		<DialogWrapper
			visible={open}
			handleClose={handleClose}
			width={isWeb ? "30%" : 350}
		>
			<Header />
			<CardContent
				sections={sections}
				checkboxStateMap={checkboxStateMap}
				isReview
				showReview
				handleCheckboxStateMapChange={handleChangeCheckboxStateMap}
			/>
			<Actions />
		</DialogWrapper>
	);
};

export default ReviewAnswersDialog;
